import { DeepMap, FieldError, FieldValues } from 'react-hook-form';

/**
 * This function search field error in Hook Form errors object.
 * Needs to be used with nested fields.
 */
export function getFormFieldError(
  fieldName: string,
  errors: DeepMap<FieldValues, FieldError>,
) {
  const path = fieldName.split(/[\.\[\]]/).filter((i) => i.length > 0);
  const result = path.reduce((accumulator, current) => {
    return accumulator ? accumulator[current] : null;
  }, errors);
  return result?.message ? result : null;
}
